import * as styles from "./ChatField.module.css";
import { IoIosSend } from "react-icons/io";
import { IoMdSend } from "react-icons/io";
import { LuSendHorizontal } from "react-icons/lu";
import { useState } from 'react';

export default function ChatField({ onSend }) {
  // Add state to track input value
  const [inputText, setInputText] = useState('');
  const [hasText, setHasText] = useState(false);

  // Handle sending the message
  const handleSend = () => {
    if (inputText.trim()) {
      onSend(inputText);
      setInputText(''); // Clear input after sending
      setHasText(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSend();
    }
  };

  const handleInputChange = (e) => {
    setInputText(e.target.value);
    setHasText(e.target.value.trim() !== '');
  };

  return <div className={styles.chatButtonContainer}>
    <input 
      type="text"
      placeholder="Still et spørsmål om produktet..."
      className={styles.chatInput}
      value={inputText}
      onChange={handleInputChange}
      onKeyPress={handleKeyPress}
    />
    <IoMdSend 
      onClick={handleSend}
      className={styles.sendIcon}
      style={{ cursor: hasText ? 'pointer' : 'not-allowed', opacity: hasText ? 1 : 0.3 }}
      disabled={!hasText}
    />
  </div>;
}
